import http from "../http-common";
import authHeader from './auth-header';

class roleManagementService {
  create(data) {
    return http.post("/create_roles", data, { headers: authHeader() });
  }

  getAllRoles() {
    return http.get("/roles", { headers: authHeader() });
  }

  getRole(SecurityRoleID) {
    return http.get(`/roles/${SecurityRoleID}`, { headers: authHeader() });
  }

  getAllPermissions() {
    return http.get("/permissions", { headers: authHeader() });
  }

  updateRoles(SecurityRoleID, data) {
    return http.put(`/update_roles/${SecurityRoleID}`, data, { headers: authHeader() });
  }

  deleteRoles(SecurityRoleID) {
    return http.delete(`/delete_roles/${SecurityRoleID}`, { headers: authHeader() });
  }

  updateRolePermissions(SecurityRoleID, data) {
    return http.put(`/update_roles/permissions/${SecurityRoleID}`, data, { headers: authHeader() });
  }
}

export default new roleManagementService();